module.exports = __webpack_public_path__ + "static/media/image_13.2fe187bf.png";